<template>
  <div>
    <v-card class="quoteSideInfo">
      <v-toolbar color="grey darken-1" dark>
        <v-toolbar-title>
          <v-icon large>{{claimIcon}}</v-icon>
          <span v-if="commonForm.appID==='MO'">Motor Claim</span>
          <span v-else-if="commonForm.appID==='TR'">Travel Claim</span>
          <span v-else>Claim</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip top>
          <v-btn flat slot="activator" @click="doSave()" :loading="claimDetail.saving">
            Save
            <v-icon right>mdi-content-save</v-icon>
          </v-btn>
          <span>Save Claim</span>
        </v-tooltip>
        <v-tooltip top>
          <v-menu bottom left slot="activator">
            <v-btn slot="activator" icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile @click="promptVoid = true">
                <v-list-tile-title>Void</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <span>More Options</span>
        </v-tooltip>
      </v-toolbar>
      <template v-if="!value">
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs4>
                <v-subheader class="queryLabel">Claim Reference No.</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span class="title">{{commonForm.clmRefNo}}</span>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">Current Status</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{currentStatusLabel}}</span>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">Intermediary</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{commonForm.intermediary}} - {{commonInfo.intermediaryName}}</span>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">Policy No.</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{commonForm.polNo}}</span>
              </v-flex>
              <v-flex xs4>
                <v-subheader class="queryLabel">Policy Benefit Section</v-subheader>
              </v-flex>
              <v-flex xs8>
                <span>{{commonForm.riskNo}}</span>
              </v-flex>
              <template v-if="commonForm.itemNo">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Item No.</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{commonForm.itemNo}}</span>
                </v-flex>
              </template>
              <template v-if="commonForm.proposalNo">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Proposal No.</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{commonForm.proposalNo}}</span>
                </v-flex>
              </template>
              <template v-if="commonForm.appName">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Insured Name</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{commonForm.appName}}</span>
                </v-flex>
              </template>
              <template v-if="commonForm.startDate">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Acceptance Date</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{formatDisplayDateTime2(commonForm.acceptDate)}}</span>
                </v-flex>
              </template>
              <template v-if="commonForm.startDate && commonForm.endDate">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Period of Cover</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{formatDate(commonForm.startDate)}} - {{formatDate(commonForm.endDate)}}</span>
                </v-flex>
              </template>
              <template v-if="commonForm.product">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Product</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{commonForm.product}} - {{commonInfo.productDesc}}</span>
                </v-flex>
              </template>
              <template v-if="commonForm.scheme">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Scheme</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{commonForm.scheme}} - {{commonInfo.schemeDesc}}</span>
                </v-flex>
              </template>
              <template v-if="commonForm.planNo">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Plan</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{commonForm.planNo}} - {{commonInfo.planDesc}}</span>
                </v-flex>
              </template>
              <template v-if="commonInfo.travelType">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Travel Type</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{travelType}}</span>
                </v-flex>
              </template>
              <template v-if="commonInfo.tripType">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Trip Type</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{tripType}}</span>
                </v-flex>
              </template>
              <template v-if="commonInfo.travelArea">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Geographical Area</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{commonInfo.travelAreaDesc}}</span>
                </v-flex>
              </template>
              <template v-if="claimForm.selectedClaimant && claimDetail.claimLifeCycle === 2 && claimDetail.claimLifeCycle === 3">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Claimant Name</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{claimForm.selectedClaimant.clmtName}}</span>
                </v-flex>
              </template>
              <template v-if="claimForm.selectedClmItem && claimDetail.claimLifeCycle === 3">
                <v-flex xs4>
                  <v-subheader class="queryLabel">Claim Item No.</v-subheader>
                </v-flex>
                <v-flex xs8>
                  <span>{{claimForm.selectedClmItem.clmItemNo}}</span>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
        </v-card-text>
      </template>
    </v-card>
    <confirm v-model="promptVoid" @ok="doVoid">
      Confirm that you want to change the status of this Claim to
      <b>Void</b>?
    </confirm>
  </div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate, formatDisplayDateTime2 } from '@/utils/date'
import { formatDisplayNumber } from '@/utils/number'
import { claimStatus } from '@/const/claims'
import { appIcon } from '@/const/underwriting'
import { tripType, travelType } from '@/const/underwriting/travel'

export default {
  data() {
    return {
      promptVoid: false
    }
  },
  computed: {
    claimDetail() {
      return this.$store.state.claims.claimDetail
    },
    currentStatusLabel() {
      if (claimStatus[this.claimDetail.commonInfo.statusCode]) {
        return claimStatus[this.claimDetail.commonInfo.statusCode]
      } else {
        return 'Unknown Status'
      }
    },
    claimForm() {
      return this.claimDetail.claimForm
    },
    commonForm() {
      return this.claimDetail.commonForm
    },
    commonInfo() {
      return this.claimDetail.commonInfo
    },
    claimIcon() {
      if (this.commonForm.appID === 'MO') {
        return appIcon.MOTOR
      } else if (this.commonForm.appID === 'TR') {
        return appIcon.TRAVEL
      } else {
        return 'mdi-cash-usd'
      }
    },
    tripType() {
      return tripType[this.commonInfo.tripType]
    },
    travelType() {
      return travelType[this.commonInfo.travelType]
    }
  },
  methods: {
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDisplayDateTime2(date) {
      return formatDisplayDateTime2(date)
    },
    doSave() {
      // Emit saving event on global event bus
      // Each quote page should listen to this and do partial Submit and save
      this.$root.$emit('saveClaim')
    },
    async doVoid() {
      this.$root.$emit('void')
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    }
  },
  mixins: [
    MessageMixin
  ],
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
@media (min-width: 1264px) {
  .quoteSideInfo {
    // Module specific override
    min-height: 425px;
  }
}
</style>
